<template>
  <div>
    <div class="asayar-text-login">
      <span>{{ asayarText }}</span>
    </div>

    <div class="computer-text-login" v-if="defined == 2">
      <span>
        <v-icon color="#943A2D" class="ml-2">mdi-alert mdi-18px</v-icon>
        {{ computerText }}
        <span class="add-computer mr-2" @click="goToDefineComputer()">ثبت کامپیوتر</span>
      </span>
    </div>
    <div class="computer-text-login" v-if="defined == 3">
      <span>
        <v-icon color="#F2BD27" class="ml-2">mdi-alert mdi-18px</v-icon>
        کاربر گرامی، درخواست شما ثبت شده است. منتظر تایید مدیر سیستم باشید.
      </span>
    </div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-img :src="frame" contain>
          <v-row no-gutters class="mt-15">
            <v-spacer></v-spacer>
            <v-col cols="10" class="mt-16">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="5" class="mt-n10">
                  <v-card class="text-card-login" elevation="3" height="80vh">
                    <v-row no-gutters>
                      <v-img :src="loginCornerImg" class="mr-n3 mt-n1">
                        <v-row class="mt-8"></v-row>
                        <v-row no-gutters class="mt-16">
                          <v-spacer></v-spacer>
                          <v-img
                            :src="logoLogin"
                            contain
                            class="mt-16"
                            height="17vh"
                            width="17vh"
                          ></v-img>
                          <v-spacer></v-spacer>
                        </v-row>
                        <v-row class="mt-5">
                          <v-spacer></v-spacer>
                          <h2 class="login-text">{{ loginText }}</h2>
                          <v-spacer></v-spacer>
                        </v-row>
                        <v-row class="mt-15">
                          <v-spacer></v-spacer>
                          <h2 class="login-text2">
                            {{ loginText2 }}
                          </h2>
                          <v-spacer></v-spacer>
                        </v-row>
                      </v-img>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="5" class="card-login-parent">
                  <login-component class="login-comp"></login-component>
                  <v-row>
                    <v-col cols="12" class="card-login-tags-part pr-16" v-if="pageType == 'login'">
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="page-title">{{ pageTitle }}</span>
                        <v-spacer></v-spacer>
                        <v-menu transition="slide-x-transition" bottom right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-if="defined == 1"
                              color="#04468B"
                              class="ml-4"
                              v-bind="attrs"
                              v-on="on"
                              @click="checkCoockieInfo()"
                            >
                              mdi-information
                            </v-icon>
                          </template>
                          <v-card width="250">
                            <v-card-text>
                              <v-row no-gutters>
                                <v-col cols="12" class="mt-3">
                                  <v-row>
                                    <h3 class="mr-3">شناسه یکتا</h3>
                                    <span class="mr-5">{{ userLogin.uniqueId }}</span>
                                  </v-row>
                                </v-col>
                                <v-col cols="12" class="mt-10">
                                  <v-row>
                                    <h3 class="mr-3">داخلی</h3>
                                    <span class="mr-12">
                                      {{
                                        validateuniqueId && validateuniqueId.extension
                                          ? validateuniqueId.extension.sipExtension
                                          : ''
                                      }}
                                    </span>
                                  </v-row>
                                </v-col>
                                <v-col cols="12" class="mt-10">
                                  <v-row>
                                    <h3 class="mr-3">ناحیه</h3>
                                    <span class="mr-12">
                                      {{
                                        validateuniqueId && validateuniqueId.zone
                                          ? validateuniqueId.zone.title
                                          : ''
                                      }}
                                    </span>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-row>
                      <v-row class="mt-8">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            dense
                            prepend-inner-icon="mdi-account mdi-18px"
                            label="نام کاربری"
                            v-on:keyup.enter="login()"
                            v-model="userLogin.userName"
                            clearable
                            clear-icon="mdi-close-circle-outline"
                            hint="نام کاربری را وارد نمایید"
                            persistent-hint
                          ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-n4">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            dense
                            prepend-inner-icon="mdi-key mdi-18px"
                            label="کلمه عبور"
                            v-model="userLogin.password"
                            v-on:keyup.enter="login()"
                            clearable
                            clear-icon="mdi-close-circle-outline"
                            :class="loginPassword"
                            :append-icon="loginPasswordIcon"
                            @click:append="showPassword()"
                          ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row style="direction: rtl" v-if="wrongLogin" class="mt-n5">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-text-field
                            type="text"
                            outlined
                            dense
                            maxlength="5"
                            @keypress="isNumber($event)"
                            v-on:keyup.enter="login()"
                            v-model="loginCaptcha"
                            hint="کد امنیتی مقابل را وارد نمایید"
                            @click:append-outer="reloadSecurityCode()"
                            append-outer-icon="mdi-reload"
                            label="کد امنیتی*"
                            prepend-inner-icon="mdi-shield-lock mdi-18px"
                          >
                            <template slot="append">
                              <v-img
                                class="ml-n6 mt-n1"
                                style="z-index: 0 !important"
                                max-height="35"
                                contain
                                max-width="150"
                                v-bind:src="'data:image/jpeg;base64,' + captchaImage"
                              ></v-img>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="forget-password-text" @click="ChangePage('password')">
                          کلمه عبور خود را فراموش کرده اید؟
                        </span>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-10 mb-6">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-btn rounded color="#04468B" dark block large @click="login()">
                            ورود
                          </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="pageType == 'computer'"
                      class="card-login-tags-part pr-16"
                    >
                      <v-row>
                        <v-spacer></v-spacer>
                        <span class="add-computer-request-text">
                          <v-icon color="#1C1B1F" class="ml-4" @click="backToHomePage()">
                            mdi-arrow-right mdi-18px
                          </v-icon>
                          درخواست ثبت کامپیوتر جدید
                        </span>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <span class="add-computer-request-discribe-text">
                            کاربر گرامی در این قسمت می توانید توضیحات خود در رابطه با درخواست ثبت
                            کامپیوتر را وارد نمایید. (مثال: ثبت کامپیوتر برای 115)
                          </span>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-textarea
                            dense
                            outlined
                            clearable
                            clear-icon="mdi-close-circle-outline"
                            label="توضیحات*"
                            v-model="computerNote"
                            autocomplete="off"
                            rows="5"
                            prepend-inner-icon="mdi-text mdi-18px"
                          ></v-textarea>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-5 mb-6">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-btn
                            rounded
                            color="#04468B"
                            dark
                            block
                            large
                            @click="addComputerRequest()"
                          >
                            ثبت درخواست
                          </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="pageType == 'password'"
                      class="card-login-tags-part pr-16"
                    >
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-row>
                            <v-col cols="1">
                              <v-icon color="#1C1B1F" class="mt-1" @click="backToLogin()">
                                mdi-arrow-right
                              </v-icon>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-center" cols="10">
                              <span class="page-title">فراموشی کلمه عبور</span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="1"></v-col>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-12">
                        <v-spacer></v-spacer>
                        <span>لطفا شماره همراه خود را جهت ارسال پیامک، وارد نمایید.</span>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-6">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            @keypress="isNumber($event)"
                            maxlength="11"
                            dense
                            prepend-inner-icon="mdi-account mdi-18px"
                            label="شماره همراه"
                            v-on:keyup.enter="sendPhoneNumberForgetPassword()"
                            v-model="forgetPasswordPhoneNumer"
                            clearable
                            clear-icon="mdi-close-circle-outline"
                          ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-10 mb-6">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-btn
                            rounded
                            color="#04468B"
                            dark
                            block
                            large
                            @click="sendPhoneNumberForgetPassword()"
                          >
                            ادامه
                          </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="pageType == 'forgetPasswodToken'"
                      class="card-login-tags-part pr-16"
                    >
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-row>
                            <v-col cols="1">
                              <v-icon color="#1C1B1F" class="mt-1" @click="backToPhoneNumberPage()">
                                mdi-arrow-right
                              </v-icon>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-center" cols="10">
                              <span class="page-title">فراموشی کلمه عبور</span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="1"></v-col>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-8">
                        <v-spacer></v-spacer>
                        <span>لطفا کد تایید ارسال شده به شماره همراه خود را وارد نمایید.</span>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-7">
                        <v-spacer></v-spacer>
                        <v-chip color="#E5F2FF" class="forget-pass-phone-edit-chips-text">
                          {{ forgetPasswordPhoneNumer }}
                          <v-icon color="#04468B" class="mr-3" @click="backToPhoneNumberPage()">
                            mdi-rename mdi-18px
                          </v-icon>
                        </v-chip>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-7">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-row>
                            <span class="token-label">کد تایید</span>
                            <v-spacer></v-spacer>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-n3">
                        <v-spacer></v-spacer>
                        <v-col cols="8" dir="ltr">
                          <v-otp-input
                            type="number"
                            length="6"
                            v-model="forgetPasswordToken"
                          ></v-otp-input>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row v-if="countDown > 0" class="mt-4">
                        <v-spacer></v-spacer>
                        <span>
                          دریافت مجدد کد تایید:
                          <span class="count-down">{{ countDown }}</span>
                        </span>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row v-else class="mt-4">
                        <v-spacer></v-spacer>
                        <span @click="sendPhoneNumberForgetPassword()" class="resend-phonenumber">
                          دریافت مجدد کد
                        </span>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-10 mb-6">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-btn
                            rounded
                            color="#04468B"
                            dark
                            block
                            large
                            @click="sendTokenForgetPassword()"
                          >
                            ادامه
                          </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="pageType == 'forgetPasswordSetPassword'"
                      class="card-login-tags-part pr-16"
                    >
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-row>
                            <v-col cols="1">
                              <v-icon color="#1C1B1F" class="mt-1" @click="backToPhoneNumberPage()">
                                mdi-arrow-right
                              </v-icon>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-center" cols="10">
                              <span class="page-title">فراموشی کلمه عبور</span>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="1"></v-col>
                          </v-row>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-6">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            dense
                            prepend-inner-icon="mdi-key mdi-18px"
                            label="کلمه عبور"
                            v-model="forgetPassword"
                            v-on:keyup.enter="setForgetPassword()"
                            clearable
                            clear-icon="mdi-close-circle-outline"
                            :class="forgetPasswordClass"
                            :append-icon="forgetPasswordIcon"
                            @click:append="showForgetPasswordPassword(1)"
                          ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-text-field
                            outlined
                            dense
                            prepend-inner-icon="mdi-key mdi-18px"
                            label="تکرار کلمه عبور"
                            v-model="forgetPasswordRepeat"
                            v-on:keyup.enter="setForgetPassword()"
                            clearable
                            clear-icon="mdi-close-circle-outline"
                            :class="forgetPasswordRepeatClass"
                            :append-icon="forgetPasswordRepeatIcon"
                            @click:append="showForgetPasswordPassword(2)"
                          ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row class="mt-10 mb-6">
                        <v-spacer></v-spacer>
                        <v-col cols="8">
                          <v-btn
                            rounded
                            color="#04468B"
                            dark
                            block
                            large
                            @click="setForgetPassword()"
                          >
                            ثبت
                          </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component>
    <!---->
  </div>
</template>
<script>
  import AlertComponent from '../components/AlertComponent.vue';
  import LoginComponent from '../components/LoginComponent.vue';

  import SharedMixin from '@/Mixins/Shared.js';
  import SharedHelper from '@/Helpers/Shared';
  import loginMixin from '@/Mixins/Login.js';
  import alertMixin from '@/Mixins/snackBar.js';
  import ExtensionMixin from '@/Mixins/BaseInformation/ExtensionMixin';
  import ClientComputerMixin from '@/Mixins/BaseInformation/ClientComputerMixin.js';
  import loginHelper from '@/Helpers/LoginHelper.js';
  import UserMixin from '@/Mixins/BaseInformation/UserMixin';
  import ZoneMixin from '@/Mixins/BaseInformation/ZoneMixin';

  export default {
    inject: ['load'],
    title: 'به آسایار خوش آمدید',
    components: {
      AlertComponent,
      LoginComponent,
    },
    mixins: [
      SharedMixin,
      loginMixin,
      alertMixin,
      SharedHelper,
      ExtensionMixin,
      loginHelper,
      UserMixin,
      ZoneMixin,
      ClientComputerMixin,
    ],
    data() {
      return {
        frame: require('@/assets/images/back.png'),
        loginCornerImg: require('@/assets/images/loginCornerImg.png'),
        logoLogin: require('@/assets/images/logoLogin.png'),
        loginText: 'سازمان اورژانس کشور',
        loginText2: 'سامانه اتوماسیون اورژانس پیش بیمارستانی',
        pageTitle: 'ورود به سامانه',
        loginPasswordIcon: 'mdi-eye',
        loginPassword: 'password',
        wrongLogin: false,
        loginCaptcha: '',
      };
    },
    mounted() {
      this.setTheme();
      if (this.$cookies.isKey('CINF')) {
        this.userLogin.uniqueId = this.$cookies.get('CINF');
        this.$store.dispatch('validateClientComputer', this.userLogin.uniqueId).then(() => {
          if (this.$store.state.clientComputerModule.successFlag) {
            this.validateuniqueId = this.$store.state.clientComputerModule.validate;
            if (this.validateuniqueId) {
              if (this.validateuniqueId.isConfirmed) {
                this.defined = 1;
              } else if (this.validateuniqueId.isConfirmed == false) {
                this.defined = 3;
              }
            } else {
              this.defined = 2;
            }
          } else {
            if (this.$store.state.clientComputerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (!this.$store.state.userModule.successFlag) {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
      } else {
        this.defined = 2;
      }
    },
    methods: {
      showPassword: function () {
        if (this.loginPasswordIcon == 'mdi-eye') {
          this.loginPasswordIcon = 'mdi-eye-off';
          this.loginPassword = '';
        } else if (this.loginPasswordIcon == 'mdi-eye-off') {
          this.loginPasswordIcon = 'mdi-eye';
          this.loginPassword = 'password';
        }
      },
      login: function () {
        if (this.wrongLogin == true) {
          //login with captcha
          this.loginUserWithCaptcha();
        } else if (this.wrongLogin == false) {
          //login without captcha
          this.loginUser();
        }
      },
      setTheme: function () {
        let theme = localStorage.getItem('theme');
        if (theme) {
          if (theme == 'blue') {
            localStorage.setItem('darkColor', '#04468B');
            localStorage.setItem('lightColor', '#0A6ADA');
            localStorage.setItem('iconColor', '#0A6ADA');
            localStorage.setItem('background', '#F6FBFF');
            localStorage.setItem('textLightColor', '#4173a8');
            localStorage.setItem('modalBorder', '#04468B');
            localStorage.setItem('oneFieldcolor', '#81A3C5');
            localStorage.setItem('newCallEffect', '#70B2FF');
            this.$vuetify.theme.currentTheme.darkColor = '#04468B';
            this.$vuetify.theme.currentTheme.lightColor = '#0A6ADA';
            this.$vuetify.theme.currentTheme.iconColor = '#0A6ADA';
            this.$vuetify.theme.currentTheme.background = '#F6FBFF';
            this.$vuetify.theme.currentTheme.textLightColor = '#4173a8';
            this.$vuetify.theme.currentTheme.modalBorder = '#04468B';
            this.$vuetify.theme.currentTheme.oneFieldcolor = '#81A3C5';
            this.$vuetify.theme.currentTheme.newCallEffect = '#70B2FF';
          }
        } else {
          localStorage.setItem('theme', 'blue');
          localStorage.setItem('darkColor', '#04468B');
          localStorage.setItem('lightColor', '#0A6ADA');
          localStorage.setItem('iconColor', '#0A6ADA');
          localStorage.setItem('background', '#F6FBFF');
          localStorage.setItem('textLightColor', '#4173a8');
          localStorage.setItem('modalBorder', '#04468B');
          localStorage.setItem('oneFieldcolor', '#81A3C5');
          localStorage.setItem('newCallEffect', '#70B2FF');
          this.$vuetify.theme.currentTheme.darkColor = '#04468B';
          this.$vuetify.theme.currentTheme.lightColor = '#0A6ADA';
          this.$vuetify.theme.currentTheme.iconColor = '#0A6ADA';
          this.$vuetify.theme.currentTheme.background = '#F6FBFF';
          this.$vuetify.theme.currentTheme.textLightColor = '#4173a8';
          this.$vuetify.theme.currentTheme.modalBorder = '#04468B';
          this.$vuetify.theme.currentTheme.oneFieldcolor = '#81A3C5';
          this.$vuetify.theme.currentTheme.newCallEffect = '#70B2FF';
        }
        this.$root.$refs.appView.themConfig();
      },
    },
  };
</script>
<style scoped>
  .card-login {
    border-top-right-radius: 0px !important;
    border-top-left-radius: 10px !important;
    border-bottom-left-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
    border-top: none !important;
    z-index: 0 !important;
    overflow-y: auto;
  }
  .card-login-parent {
    margin-right: -5.2% !important;
    margin-top: -3vh !important;
    z-index: 9 !important;
  }
  .login-comp {
    position: absolute;
  }
  .card-login-tags-part {
    margin-top: 22%;
    z-index: 99;
    height: 58vh;
    overflow-y: auto !important;
  }
  .text-card-login {
    background: #04468b !important;
    border-radius: 10px !important;
    z-index: 0 !important;
  }
  @media only screen and (min-width: 1280px) {
    .rectangle2 {
      width: 22vh !important;
      height: 7vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 22.8% !important;
      right: 48.7% !important;
      z-index: 99 !important;
      border-top-left-radius: 40px !important;
    }

    .tst {
      width: 14vh !important;
      height: 11vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 17% !important;
      right: 48.6% !important;
      border-top-right-radius: 10px !important;
      border-top-left-radius: 2px !important;
      filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.12));
    }
    .tst2 {
      width: 2.5vh !important;
      height: 11vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 16.5% !important;
      right: 55.8% !important;
      border-top-left-radius: 10px !important;
      transform: rotate(30deg);
      filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.12));
    }
    .tst3 {
      width: 2vh !important;
      height: 7.5vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 18% !important;
      right: 55.3% !important;
      border-top-left-radius: 10px !important;
    }
    .tst4 {
      width: 6vh !important;
      height: 5vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 17% !important;
      right: 52.6% !important;
      border-top-left-radius: 10px !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .rectangle2 {
      width: 22vh !important;
      height: 9vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 22.8% !important;
      right: 48.7% !important;
      z-index: 99 !important;
      border-top-left-radius: 100px !important;
    }

    .tst {
      width: 14vh !important;
      height: 11vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 17% !important;
      right: 48.7% !important;
      border-top-right-radius: 10px !important;
      border-top-left-radius: 2px !important;
      filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.12));
    }
    .tst2 {
      width: 2.5vh !important;
      height: 11vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 16.5% !important;
      right: 55.8% !important;
      border-top-left-radius: 10px !important;
      transform: rotate(30deg);
      filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.12));
    }
    .tst3 {
      width: 2vh !important;
      height: 7.5vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 18% !important;
      right: 55.3% !important;
      border-top-left-radius: 10px !important;
    }
    .tst4 {
      width: 6vh !important;
      height: 5vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 17% !important;
      right: 52.6% !important;
      border-top-left-radius: 10px !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .rectangle2 {
      width: 22vh !important;
      height: 7vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 22.8% !important;
      right: 48.7% !important;
      z-index: 99 !important;
      border-top-left-radius: 40px !important;
    }

    .tst {
      width: 14vh !important;
      height: 11vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 17% !important;
      right: 48.6% !important;
      border-top-right-radius: 10px !important;
      border-top-left-radius: 2px !important;
      filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.12));
    }
    .tst2 {
      width: 2.5vh !important;
      height: 11vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 16.5% !important;
      right: 55.8% !important;
      border-top-left-radius: 10px !important;
      transform: rotate(30deg);
      filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.12));
    }
    .tst3 {
      width: 2vh !important;
      height: 7.5vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 18% !important;
      right: 55.3% !important;
      border-top-left-radius: 10px !important;
    }
    .tst4 {
      width: 6vh !important;
      height: 5vh !important;
      background: white !important;
      position: absolute;
      z-index: 9 !important;
      top: 17% !important;
      right: 52.6% !important;
      border-top-left-radius: 10px !important;
    }
  }
  .rectangle {
    width: 20.3vh !important;
    height: 2vh !important;
    background: white !important;
    position: absolute;
    z-index: 9 !important;
    margin-top: 22.5vh !important;
    margin-right: 100.6vh !important;
    border-top-left-radius: 20px !important;
  }
  .login-text {
    font-family: 'Shekasteh2Beta' !important;
    font-size: 28px;
    color: white;
  }
  @supports (-webkit-text-stroke: 0.001px white) {
    .login-text2 {
      font-family: 'Shekasteh2Beta' !important;
      font-size: 28px;
      -webkit-text-stroke: 0.001px white;
      -webkit-text-fill-color: transparent;
    }
  }
  .asayar-text-login {
    position: absolute;
    font-size: 34px;
    font-family: 'Shekasteh2Beta';
    color: #04468b;
    top: 16%;
    right: 53%;
    z-index: 99;
    font-weight: normal !important;
  }
  .computer-text-login {
    position: absolute;
    font-size: 13px;
    color: #212121;
    top: 18%;
    right: 61%;
    z-index: 99;
    font-weight: normal !important;
    background: #fff5f3;
    padding-top: 7px;
    padding-bottom: 7px;
    padding-right: 14px;
    padding-left: 14px;
    letter-spacing: normal;
    border-radius: 6px !important;
  }
  .page-title {
    color: #04468b;
    font-size: 20px;
    font-weight: 500;
  }
  >>> .password .v-text-field__slot {
    font-family: 'password' !important;
  }
  .forget-password-text {
    color: #2c2c2c;
    cursor: pointer;
    font-size: 12px;
  }
  .forget-pass-phone-edit-chips-text {
    color: #04468b !important;
  }
  .token-label {
    color: #1c1b1f !important;
  }
  .count-down {
    color: #04468b !important;
  }
  .resend-phonenumber {
    cursor: pointer !important;
  }
  .add-computer {
    color: #04468b;
    cursor: pointer;
    font-weight: 600;
  }
  .add-computer-request-text {
    color: #04468b;
    font-size: 18px;
  }
  .add-computer-request-discribe-text {
    color: #212121;
    font-size: 13px;
  }
</style>
